import React, { Component } from "react";
import "./CollectingAverage.css";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";

class CollectingAverage extends Component {
  constructor(props) {
    super(props);
    this.willUnmount = false;
    this.state = {
      status: 0,
    };
    const pollingIntervalMinutes = 1;
    const poll = (operatorID) => {
      OperatorEndpoints.getOperatorStatuses(operatorID)
        .then((ac) => {
          if (!this.willUnmount) {
            this.setState({
              status: ac,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          if (!this.willUnmount) {
            setTimeout(() => poll(operatorID), 60 * 1000 * pollingIntervalMinutes);
          }
        });
    };
    poll(props.operatorID);
  }

  componentWillUnmount = () => {
    this.willUnmount = true;
  };

  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <div className="collectingAverage green">
        {this.state.status >= 0 ? (
          <div
            className={
              this.state.status >= 0 && this.state.status <= 8
                ? "posgreen circle1 table"
                : "posgreen circle2 table"
            }
          >
            +{this.state.status.toString().substring(0, 4)}m
          </div>
        ) : (
          <div
            className={
              this.state.status <= -1 && this.state.status >= -8
                ? "negred circle1 table"
                : "negred circle2 table"
            }
          >
            {this.state.status.toString().substring(0, 4)}m
          </div>
        )}
      </div>
    );
  }
}

export default CollectingAverage;
